import { abyssColors, primary } from '@/theme/colors';
import { hexToRgba } from '@/utils';

export const autoCompleteStyles = {
  background: abyssColors.primary[50],
  '& .MuiAutocomplete-input': {
    minWidth: '0px !important',
  },
  '& fieldset': {
    border: `1px solid '${abyssColors.primary[50]}' !important`,
  },
};

export const autoCompleteInputStyles = {
  py: '0px !important',
  height: 32,
  '& .MuiInputBase-root': {
    fontSize: '1.4rem',
    height: 32,
  },
  '& input::placeholder': {
    fontSize: '1.4rem',
  },
};

export const filtersContainerStyles = {
  mt: 2,
  borderRadius: '4px',
  padding: '12px 16px',
  backgroundColor: hexToRgba(primary.light, 0.1),
  flexWrap: 'wrap',
  gap: 2,
};
